import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

import { Breadcrumb, BreadcrumbItem } from '@/components/shared/Breadcrumb';

import { StyledContainer, ContainerType } from './StyledContainer';
import { NoticeContainer } from '@/components/shared/Notice';

type Props = {
  title: string;
  headerTitle?: string;
  breadcrumbItems?: BreadcrumbItem[];
  hasHeaderDivider?: boolean;
  hasInnerWrapper?: boolean;
  containerType?: ContainerType;
  children?: ReactNode;
};

export const PageRootWrapper: React.FC<Props> = (props) => {
  const {
    children,
    title,
    headerTitle,
    breadcrumbItems,
    containerType,
    hasHeaderDivider = false,
    hasInnerWrapper = true,
  } = props;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      {breadcrumbItems && <Breadcrumb items={breadcrumbItems} />}

      <NoticeContainer />

      <StyledContainer
        headerTitle={headerTitle}
        containerType={containerType}
        hasHeaderDivider={hasHeaderDivider}
        hasInnerWrapper={hasInnerWrapper}
      >
        {children}
      </StyledContainer>
    </>
  );
};
